import {
  GetOrdersAndQuotesMatchingIdInsightRequestParams,
  GetOrdersAndQuotesMatchingIdInsightRequestQueryString,
  GetOrdersAndQuotesMatchingIdInsightResponse,
} from '@snap-types/actions/get-orders-and-quotes-matching-id-insight';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildTeamSnapQuoteUrl } from '@ui/store/api-builder/build-team-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

export const [
  getOrdersAndQuotesMatchingIdInsight,
  useGetOrdersAndQuotesMatchingIdInsightMutation,
] = injectMutation<
  {
    params: GetOrdersAndQuotesMatchingIdInsightRequestParams;
    query: GetOrdersAndQuotesMatchingIdInsightRequestQueryString;
  },
  GetOrdersAndQuotesMatchingIdInsightResponse
>(
  `${QUOTE_BUILDER_SLICE_NAME}/getOrdersAndQuotesMatchingIdInsight`,
  ({ params, query }) => ({
    url: buildTeamSnapQuoteUrl({
      siteUuid: params.siteUuid,
      teamUuid: params.teamUuid,
      snapQuoteUuid: params.snapQuoteUuid,
      path: 'part-insights/matching-orders-and-quotes',
    }),
    method: 'GET',
    params: { ...query },
  }),
);
